/**
 * Selection math for DataTable's multi-row checkboxes (select-all on the page,
 * select-all in a group). Pure, so it is unit-tested apart from the table.
 */

/** Whether every id, or only some, is selected. Empty `ids` is neither. */
export function selectionState(selected: ReadonlySet<string>, ids: readonly string[]): { all: boolean; some: boolean } {
  const n = ids.filter((id) => selected.has(id)).length
  return { all: ids.length > 0 && n === ids.length, some: n > 0 && n < ids.length }
}

/** Toggle a block of ids: deselect them all when all are selected, otherwise add the missing ones (order kept). */
export function toggleMany(selected: readonly string[], ids: readonly string[]): string[] {
  const have = new Set(selected)
  const block = new Set(ids)
  return ids.length > 0 && ids.every((id) => have.has(id))
    ? selected.filter((id) => !block.has(id))
    : [...selected, ...ids.filter((id) => !have.has(id))]
}
